import {
    Component,
    OnInit,
    Input,
    Output,
    EventEmitter
} from '@angular/core';

@Component({
    selector: 'app-market-toggle',
    templateUrl: './toggle.component.pug',
    styleUrls: ['./toggle.component.less']
})
export class ToggleComponent implements OnInit {

    @Input() expanded = false;

    @Output() expand: EventEmitter<any> = new EventEmitter();
    @Output() collapse: EventEmitter<any> = new EventEmitter();

    constructor() { }

    ngOnInit() {
    }

    onExpand() {
        this.expanded = true;
        this.expand.emit();
    }

    onCollapse() {
        this.expanded = false;
        this.collapse.emit();
    }
}
